import { lazy } from 'react';

export const AutoService = lazy(() => import('./ui/AutoService'));
